import { createReducer } from "reduxsauce";

import Actions from "modules/i18n/locale-actions";
import UserActions from "modules/user/user-actions";
import { DEFAULT_LOCALE } from "modules/i18n/locale-config";
import { mapBackendLocaleToFrontendLocale } from "./locale-utils";

const INITIAL_STATE = {
  locale: DEFAULT_LOCALE.code
};

const changeLocaleInternal = (state, localeCode) => {
  return {
    ...state,
    locale: localeCode
  };
};

const changeLocale = (state, { localeCode }) =>
  changeLocaleInternal(state, localeCode);

const changeLocaleWithUserSetting = (state, { user }) =>
  changeLocaleInternal(state, mapBackendLocaleToFrontendLocale(user.language));

export const HANDLERS = {
  [Actions.Types.LOCALE_CHANGED]: changeLocale,
  [UserActions.Types.USER_FETCHED]: changeLocaleWithUserSetting
};

export default createReducer(INITIAL_STATE, HANDLERS);



// WEBPACK FOOTER //
// ./src/modules/i18n/locale-reducer.js